import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import { Web } from '@material-ui/icons';
import DataTime from '../../Components/DateFormat';


export default ({ListEsp, InfIdUse, InfIdConta, IdUse, IdConta, setAddList, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo, MsgDesativar}) => {

const [Titulo, setTitulo] = useState("Vizualizar Ação");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [Img2, setImg2] = useState("../assets/avatarimg.png");
const [Imgs2, setImgs2] = useState("");
const [Imgs1Res, setImgs1Res] = useState("");
const [Nome, setNome] = useState("");
const [Telefone, setTelefone] = useState("");
const [TelefoneRes, setTelefoneRes] = useState("");
const [Mensalidade, setMensalidade] = useState("0000");
const [DiaMes, setDiaMes] = useState("00");;
const [End, setEnd] = useState("");
const [Num, setNum] = useState("");
const [Bairro, setBairro] = useState("");
const [Cidade, setCidade] = useState("");
const [Estado, setEstado] = useState("");
const [Versao, setVersao] = useState("1.0.0");
const [MedidasAtiv, setMedidasAtiv] = useState(true);
const [GratisAtiv, setGratisAtiv] = useState(false);
const [VerSofredo, setVerSofredo] = useState("");

useEffect(() => {
  if(VerSofredo){
   PreencherFormulario()  
  }
     
  }, [VerSofredo])
useEffect(() => {
    VerSofredoBanco()   
  }, [ListEsp])



  const VerSofredoBanco = () => {
     setVerSofredo(null); 
    Api.TADadosPermissoesAcao(ListEsp, setVerSofredo) 
  };
 
 const handleToggle1 = () => {
    setGratisAtiv(!GratisAtiv);
  };
   
     const handleToggle4 = () => {
    setMedidasAtiv(!MedidasAtiv);
  };
const PreencherFormulario = () => {
     
      
  }


  const criando = ()=>{

    var TAMensalidade = parseInt(Mensalidade)
    var TADiaMes = parseInt(DiaMes)
 
    if(GratisAtiv){
    if(Nome !=="" && Nome !==" " && Nome !=="  " && Nome !=="   " && Nome !=="    " && Nome !=="     " && Nome !=="      "
    && Nome !=="       " && Nome !=="        " && Nome !=="         " && Nome !=="          " 
    && Nome !=="           " ){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
        Api.TAEditarAlunos(ListEsp, Id, TelefoneRes, Imgs1Res, GratisAtiv, IdConta, InfIdUse,  IdUse, MedidasAtiv, Versao,  Nome,  Imgs2,  Telefone,   Mensalidade, DiaMes,  Estado, Cidade, Bairro, Num, End, UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("Preencha o Nome Completo do Aluno.")
    }

    } else {
    if(TADiaMes > 0 && TADiaMes < 27 ){
    if(TAMensalidade >= 0){
    if(Nome !=="" && Nome !==" " && Nome !=="  " && Nome !=="   " && Nome !=="    " && Nome !=="     " && Nome !=="      "
    && Nome !=="       " && Nome !=="        " && Nome !=="         " && Nome !=="          " 
    && Nome !=="           " ){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true)

         Api.TAEditarAlunos(ListEsp, Id, TelefoneRes, Imgs1Res, GratisAtiv, IdConta, InfIdUse,  IdUse, MedidasAtiv, Versao,  Nome,  Imgs2,  Telefone,   Mensalidade, DiaMes,  Estado, Cidade, Bairro, Num, End, UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList);
     
        } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("Preencha o Nome Completo do Cliente.")
    }
    
    } else {
        setMsgErro("Valor Mensalidade só pode Número.")
    }
    } else {
        setMsgErro("Dia do Mês não é valido.")
    }  
   } 
  }


  const ColocarImg2 = (e)=>{
    const reader = new FileReader()
    reader.onload = () => {
      if(reader.readyState === 2) {
        setImg2(reader.result);
      }
    }
   reader.readAsDataURL(e.target.files[0]);
    setImgs2(e.target.files[0]);
  }
  const ExcImg2 = ()=>{
   
    setImgs2("");
    setImg2("../assets/avatarimg.png");
  }

  
     
      
   

        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="far fa-hand-pointer" /> Ação 
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                      
                   
                    
                     {MsgErro !== "" &&
                    <>
                    <div class="alert alert-danger alert-dismissible">
                  
                  <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                  {MsgErro}
                </div>
                   
                    </>
                    }
                    </>
                    }
                    <strong>Data da Execução</strong><br />
                   <string><DataTime 
                          DateIni={ListEsp.dataDaAcao/1000}
                          /></string><br />
                     <strong>Nome do Executor</strong><br />
                   <string>{ListEsp.Nome}</string><br />
                    <strong>Telefone do Executor</strong><br />
                   <string>{ListEsp.Telefone}</string><br />
                   <strong>Executor na Sessão</strong><br />
                   <string>{ListEsp.Sessão}</string><br />
                   <strong>Executor a Ação</strong><br />
                   <string>{ListEsp.Acao}</string><br />

                  
                 
                     
                  </address>
                    </div>
                      <div className="col-sm-4 invoice-col">
                    <address>
                      {VerSofredo &&
                      <>
                       <h4>
                        Permissões
                       </h4>
                     <strong>Nome do Grupo</strong><br />
                     <string>{VerSofredo.Nome}</string>
                    <br />
                 
                  <strong>Data de Criação</strong><br />
                         <string><DataTime 
                            DateIni={VerSofredo.dataDaCricao/1000}
                            /></string><br />
                     
                     </>

                      }
                    </address>
                   </div>
                    <div className="col-sm-4 invoice-col">
                    <address>
                     {VerSofredo &&
                      <>
                    
                        </>

                      }
                    </address>
                   </div>
              </div>
              <div className="row no-print">
              </div>
              
            
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}